import React from "react";
import HelpIcon from "@material-ui/icons/Help";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import TestCaseRating from "../../../models/TestCaseRating.model";

const ICONS_BY_RATING: { [R in TestCaseRating]: React.ReactElement } = {
  FAILED: <ThumbDownIcon />,
  PASSED: <ThumbUpIcon />,
  PARTIALLY_PASSED: <ThumbsUpDownIcon />,
  NOT_RATED: <HelpIcon />,
};

interface TestCaseRatingIconProps {
  rating: TestCaseRating;
}
const TestCaseRatingIcon: React.FC<TestCaseRatingIconProps> = ({ rating }) => {
  return ICONS_BY_RATING[rating] || null;
};

export default TestCaseRatingIcon;
